import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EscolaModel } from '../models/escola.model';
import { ApiVersion, ApiService } from 'src/app/services/api.service';
import { Observable } from 'rxjs';

@Injectable()
export class EscolaService {
    constructor(private http: HttpClient, private apiService: ApiService) {}

    getPorPeriodo(hashPeriodo: string): Observable<EscolaModel[]> {
        return this.http.get<EscolaModel[]>(
            `${this.apiService.getUrl()}/${ApiVersion}/escolas/${hashPeriodo}`
        );
    }
}
